var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageSid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4607 2.78625C11.166 -0.50847 5.83336 -0.508964 2.53817 2.78625C-0.111268 5.43566 -0.611921 9.37514 0.954438 12.5124L0.0860522 16.3322C-0.0268198 16.8286 0.418139 17.2738 0.914803 17.1609L4.73455 16.2925C10.2884 19.0654 16.9301 15.051 16.9301 8.74756C16.9301 6.49573 16.0531 4.37863 14.4607 2.78625ZM10.2581 10.8469H4.98215C4.59971 10.8469 4.28969 10.5369 4.28969 10.1545C4.28969 9.77202 4.59971 9.46199 4.98215 9.46199H10.2581C10.6405 9.46199 10.9506 9.77202 10.9506 10.1545C10.9506 10.5369 10.6405 10.8469 10.2581 10.8469ZM12.0168 8.0331H4.98215C4.59971 8.0331 4.28969 7.72308 4.28969 7.34064C4.28969 6.9582 4.59971 6.64817 4.98215 6.64817H12.0168C12.3992 6.64817 12.7092 6.9582 12.7092 7.34064C12.7092 7.72308 12.3992 8.0331 12.0168 8.0331Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSid);
export default __webpack_public_path__ + "static/media/messageSid.95ffaf0e9d4cff952c9bc7828b95d6c5.svg";
export { ForwardRef as ReactComponent };